export default __webpack_public_path__ + "static/media/replyTableIcon.4694c5a6.svg";